import { AppState } from '../../app/state/AppState';
import { ISiteNameSansId } from '../../ts/ServerApi/types/ISiteNameSansId';


export function selectSites(state: AppState): ReadonlyArray<ISiteNameSansId> {
  return state.sites;
}
